var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',{attrs:{"fluid":""}},[_c('h1',{staticStyle:{"font-size":"26px"}},[_vm._v(_vm._s(_vm.page.title))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.page.content)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }